import styled from "styled-components";

export const DetailWrapper = styled.div`
  position: relative;

  .site-page-header .ant-page-header-heading {
    justify-content: center;
  }
  #myform .ant-form-item {
    margin: 0px !important;
  }

  /* ----------------------------------------------------------------
     Action bar — button row at top of form
     ---------------------------------------------------------------- */
  .detail-action-bar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    padding: 12px 16px;
    border-bottom: 1px solid #f0f0f0;
    background: #fafafa;
    border-radius: 8px 8px 0 0;
    flex-wrap: wrap;
  }

  /* Buttons: auto width so they don't stretch */
  .ant-btn {
    z-index: 16;
    width: auto !important;
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
  }

  /* ----------------------------------------------------------------
     Vertical form — block layout, items stack naturally
     ---------------------------------------------------------------- */
  form.ant-form.ant-form-vertical {
    display: block;
  }

  /* 2-column grid for create-new forms */
  form.detail-form-create.ant-form-vertical {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    column-gap: 32px;
    row-gap: 4px;
  }

  form.detail-form-create > .ant-divider,
  form.detail-form-create > .form-section-header {
    grid-column: 1 / -1;
  }

  @media (max-width: 900px) {
    form.detail-form-create.ant-form-vertical {
      grid-template-columns: 1fr;
    }
  }

  /* ----------------------------------------------------------------
     Input focus ring — theme blue
     ---------------------------------------------------------------- */
  .ant-input:focus,
  .ant-input-focused {
    border-color: #4482FF !important;
    box-shadow: 0 0 0 2px rgba(68, 130, 255, 0.12) !important;
  }

  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-color: #4482FF !important;
    box-shadow: 0 0 0 2px rgba(68, 130, 255, 0.12) !important;
  }

  .ant-picker-focused {
    border-color: #4482FF !important;
    box-shadow: 0 0 0 2px rgba(68, 130, 255, 0.12) !important;
  }

  /* ----------------------------------------------------------------
     Input border-radius
     ---------------------------------------------------------------- */
  .ant-input,
  .ant-input-affix-wrapper,
  .ant-select-selector,
  .ant-picker,
  .ant-input-number {
    border-radius: 6px !important;
  }

  /* ----------------------------------------------------------------
     Labels — compact uppercase style above inputs
     ---------------------------------------------------------------- */
  .ant-form-item-label {
    padding: 0 0 2px !important;
    line-height: 1.3em;
  }

  .ant-form-item-label > label {
    font-size: 11px !important;
    font-weight: 700 !important;
    color: #8c8c8c !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
    height: auto !important;
  }

  .ant-form-item-label > label.ant-form-item-required::before {
    font-size: 11px;
  }

  /* Form item spacing */
  .detailForm .ant-form-item {
    margin-bottom: 16px;
  }

  .flex-form .ant-form-item {
    margin-bottom: 1px !important;
  }

  /* ----------------------------------------------------------------
     Read-only field value — subtle bottom border
     ---------------------------------------------------------------- */
  .form-field-value {
    display: block;
    padding: 5px 0;
    color: #202020;
    font-size: 14px;
    line-height: 1.5715;
    min-height: 22px;
    border-bottom: 1px solid #f0f0f0;
  }

  /* ----------------------------------------------------------------
     Section header — blue accent bar + title + line
     ---------------------------------------------------------------- */
  .form-section-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 24px 0 8px;
    width: 100%;
  }
  .form-section-header-accent {
    width: 4px;
    height: 18px;
    border-radius: 2px;
    background: #4482FF;
    flex-shrink: 0;
  }
  .form-section-header-text {
    font-size: 12px;
    font-weight: 700;
    color: #4b5563;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    white-space: nowrap;
  }
  .form-section-header-line {
    flex: 1;
    height: 1px;
    background: #e5e7eb;
  }

  /* ----------------------------------------------------------------
     Close button — absolute top-right circle with hover animation
     ---------------------------------------------------------------- */
  .detail-close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    z-index: 1000;
    background-color: #4097ff !important;
    color: white !important;
    border-radius: 50% !important;
    width: 36px !important;
    height: 36px !important;
    display: flex !important;
    justify-content: center;
    align-items: center;
    border: none !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    padding: 0 !important;
  }
  .detail-close-btn:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }
  .detail-close-btn:active {
    transform: scale(0.95);
  }

  /* ----------------------------------------------------------------
     Misc
     ---------------------------------------------------------------- */
  .slds-text-title--caps, .slds-text-body--small, .slds-align-middle {
    display: grid;
    justify-content: center;
  }

  .disabled-input {
    color: black !important;
  }

  .slds-input {
    border: 1px solid #dddbda !important;
  }

  .ant-input[disabled] {
    color: black !important;
    background-color: rgb(247 247 247 / 55%);
  }

  .ant-form-item-control-input-content {
    text-align: left;
  }

  .ant-form-item-control-input {
    border-radius: 2pt;
    min-height: 28px !important;
  }

  /* ----------------------------------------------------------------
     AddAndDelete tag widget
     ---------------------------------------------------------------- */
  .AddAndDelete {
    .main {
      border: 1px solid #E9E9E9;
      border-radius: 4px;
      padding: 5px;
      width: 100%;
    }

    .tag {
      position: relative;
      margin: 3px;
      border: 1px dashed #3b9de9;
      border-radius: 4px;
      padding: 0 8px;
      line-height: 30px;
      color: #666666;
      background: rgba(255, 255, 255, 0.7);
    }

    .delete {
      position: absolute;
      top: -1px;
      right: -1px;
      width: 16px;
      height: 16px;
      cursor: pointer;
      user-select: none;
      -moz-user-select: none;
      -webkit-user-drag: none;
      -webkit-user-select: none;
      -ms-user-select: none;
    }

    .inputs {
      margin-top: 10px;
    }

    input {
      width: 10rem !important;
      box-sizing: border-box;
      margin: 0;
      padding: 5px !important;
      display: inline-block;
      min-width: 0;
      color: rgba(0, 0, 0, 0.85);
      line-height: 1.5715;
      background-color: #fff;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
      transition: all 0.3s;
    }

    button {
      margin-left: 10px;
      background-color: #3789c7;
      border: none;
      color: white;
      padding: 5px 15px;
      display: inline-block;
      font-size: 16px;
      border-radius: 2px;
    }
  }

  /* ----------------------------------------------------------------
     Responsive width helpers
     ---------------------------------------------------------------- */
  @media (min-width: 1024px) {
    .lg\\:w-1\\/3 {
      width: 30% !important;
    }
    .lg\\:w-1\\/4 {
      width: 21% !important;
    }
  }

  @media (min-width: 768px) {
    .md\\:w-1\\/2 {
      width: 45%;
    }
    .md\\:w-1\\/4 {
      width: 20%;
    }
  }

  @media (max-width: 568px) {
    .sm\\:w-full {
      width: 100%;
    }
  }
`;
